import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
.use(initReactI18next)
.init({
    resources: {
        en: {
            translation: {
                "Download": "Download",
                "QrCode": "Qr Code",
                "Open":"Open",
                "CopyLink":"Copy Link",
                "LinkCopied":"Link copied to clipboard",
                "Progress": "Progress",
                "ImportantLinks": "Important Links",
                "DonateNow": "Donate Now",
                "AboutUs": "About Us",
                "ChoosePayment":"Choose Your Payment Method",
                "ContactUs": {
                    "Title": "Get in Touch",
                    "Description": "Have questions or feedback? We'd love to hear from you. Fill out the form below and we'll get back to you as soon as possible.",
                    "Form": {
                        "FirstName": "First Name",
                        "Email": "Email",
                        "PhoneNumber": "Phone Number",
                        "Subject": "Subject",
                        "Message": "Message",
                        "EnterFirstName": "Enter your first name",
                        "EnterEmail": "Enter your email",
                        "EnterPhone": "Enter your phone number",
                        "EnterSubject": "Enter subject",
                        "EnterMessage": "Enter your message",
                        "SendMessage": "Send Message",
                        "Sending": "Sending...",
                        "Validation": {
                            "FirstNameRequired": "First name is required",
                            "EmailRequired": "Email is required",
                            "EmailInvalid": "Please enter a valid email address",
                            "PhoneRequired": "Phone number is required",
                            "PhoneInvalid": "Please enter a valid phone number",
                            "SubjectRequired": "Subject is required",
                            "MessageRequired": "Message is required",
                            "MessageLength": "Message must be at least 10 characters long"
                        },
                        "Success": "Message sent successfully",
                        "Error": "Failed to send message. Please try again."
                    }
                },
                "AboutCampaign": "About Campaign",
                                                                                                                                                                                                                                                                                                                                                                        "Share": "Share",
                "CampaignGallery": "Campaign Gallery",
                "GeneralDonation": {
                    "Processing": "Processing your donation...",
                    "DonationType": "Donation Type",
                    "DonationTypeToggle": "Donation Type",
                    "DonationProgram": "Donation Program",
                    "NoPrograms": "No programs available for this type"
                },
                "DonationForm":{
                    "DonationAmount": "Donation Amount",
                    "FirstName": "First Name",
                    "LastName": "Last Name",
                    "Email": "Email",
                    "PhoneNumber": "Phone Number",
                    "Message": "Message",

                    "EnterYourFirstName": "Enter Your First Name",
                    "EnterYourLastName": "Enter Your Last Name",
                    "EnterYourEmail": "Enter Your Email",
                    "EnterYourPhoneNumber": "Enter Your Phone Number",
                    "EnterYourMessage": "Enter Your Message",
                    "DonateAnonymously": "Donate Anonymously",
                    "CustomAmount": "Custom Amount",
                    "EnterCustomAmount": "Enter Custom Amount",
                    "Validation": {
                        "FirstNameRequired": "First name is required",
                        "LastNameRequired": "Last name is required",
                        "EmailRequired": "Email is required",
                        "EmailInvalid": "Please enter a valid email address",
                        "PhoneNumberRequired": "Phone number is required",
                        "CustomAmountRequired": "Custom amount must be at least 10",
                        "PaymentMethodRequired": "Payment method is required"
                    },
                    "OneTimeDonation": "One-Time Donation",
                    "MonthlyDonation": "Monthly Donation",
                    "NoonOnlyNotice": "Monthly payment is processed via Noon gateway only",
                    "PaymentMethod": "Payment Gateway",
                    "Disclaimer": "For your convenience, please select your preferred payment gateway. If the transaction fails on one gateway, you can try again on the other available gateways.",
                    "SecurePaymentDisclaimer": "All your data and transactions are secure"
                },
                "Membership": {
                    "WelcomeBack": "Welcome Back",
                    "CreateAccount": "Create Account",
                    "SignInToContinue": "Sign in to continue to your account",
                    "JoinUs": "Join us and start making a difference",
                    "Login": "Login",
                    "Register": "Register",
                    "Username": "Username",
                    "EnterUsername": "Enter your username",
                    "PhoneNumber": "Phone Number",
                    "EnterPhoneNumber": "Enter your phone number",
                    "Email": "Email",
                    "EnterEmail": "Enter your email",
                    "Password": "Password",
                    "EnterPassword": "Enter your password",
                    "ConfirmPassword": "Confirm Password",
                    "EnterConfirmPassword": "Confirm your password",
                    "SignIn": "Sign In",
                    "OrLoginWith": "Or login with",
                    "CreateAccount": "Create Account",
                    "ForgotPassword": "Forgot Password",
                    "LoginToDonate": "Please login or create an account to continue with your donation.",
                    "Validation": {
                        "UsernameRequired": "Username is required",
                        "PhoneRequired": "Phone number is required",
                        "EmailRequired": "Email is required",
                        "EmailInvalid": "Email is invalid",
                        "PasswordRequired": "Password is required",
                        "PasswordLength": "Password must be at least 6 characters",
                        "PasswordsDoNotMatch": "Passwords do not match"
                    },
                    "LoginSuccess": "Login successful",
                    "RegisterSuccess": "Registration successful, please verify your account via email",
                    "RegisterFailed": "Registration failed"
                },
                "Callback": {
                    "Title": "Payment Details",
                    "Loading": "Loading payment details...",
                    "NoDetails": "No payment details found",
                    "Labels": {
                        "Name": "Name",
                        "Description": "Description",
                        "Status": "Status",
                        "Date": "Date",
                        "Amount": "Amount",
                        "Email": "Email",
                        "Mobile": "Mobile",
                        "PaymentMethod": "Payment Method",
                        "TransactionId": "Transaction ID"
                    },
                    "Status": {
                        "Completed": "Completed",
                        "Unpaid": "Unpaid"
                    },
                    "Buttons": {
                        "Back": "Back",
                        "Print": "Print",
                        "Copy": "Copy to clipboard"
                    },
                    "Print": {
                        "Title": "Payment Receipt"
                    }
                },
                "DonorProfile": {
                    "Title": "Donor Profile",
                    "Back": "Back",
                    "Logout": "Logout",
                    "ContactInformation": "Contact Information",
                    "DonationStats": "Donation Stats",
                    "TotalDonations": "Total Donations",
                    "TotalGiven": "Total Given",
                    "LastDonation": "Last Donation",
                    "DonationHistory": "Donation History",
                    "ShowingDonations": "Showing {{count}} donations",
                    "Donations": "Donations",
                    "Subscriptions": "Subscriptions",
                    "ShowingSubscriptions": "Showing {{count}} subscriptions",
                    "Table": {
                        "Campaign": "Campaign",
                        "Amount": "Amount",
                        "Date": "Date",
                        "StartDate": "Start Date",
                        "NextBillingDate": "Next Billing Date",
                        "Recurring": "Recurring",
                        "Normal": "Normal",
                        "NextMonth": "Next Month",
                        "CalendarMonth": "Calendar Month",
                        "Status": "Status",
                        "TransactionId": "Transaction ID",
                        "LinkGenerated": "Unpaid",
                        "DonationsHistory": "Donations History",
                        "SubscriptionsHistory": "Subscriptions History",
                        "RecurringMode": "Recurring Mode",
                        "Actions": "Actions"
                    }, 
                    "RecurringModal": {
                        "Title": "Manage Recurring Subscription",
                        "StartedOn": "Started on",
                        "RecurringStatus": "Recurring Status",
                        "SubscriptionStatus": "Subscription Status",
                        "SubscriptionActive": "Your subscription is active",
                        "SubscriptionSuspended": "Your subscription is suspended",
                        "SubscriptionDetails": "Subscription Details",
                        "Mode": "Mode",
                        "Amount": "Amount",
                        "NextBilling": "Next Billing Date",
                        "CancelSubscription": "Cancel Recurring Subscription",
                        "Close": "Close",
                        "StatusUpdated": "Subscription status updated successfully",
                        "UpdateFailed": "Failed to update subscription status",
                        "SubscriptionCancelled": "Subscription cancelled successfully",
                        "CancelFailed": "Failed to cancel subscription"
                    },
                    "Loading": "Loading...",
                    "NoDonations": "No donations",
                    "DonateNow": "Donate Now",
                    "CompleteProfilePrompt": "Please complete your profile by providing a phone number.",
                    "UpdateNow": "Update Now",
                    "CompleteYourProfile": "Complete Your Profile",
                    "PhoneMissingPrompt": "Please provide a phone number so we can better assist you and keep you updated on your impact.",
                    "Skip": "Skip for now",
                    "Save": "Save",
                    "PhoneUpdated": "Phone number saved successfully!",
                    "ErrorFetchingData": "Failed to load profile data"
                },
                "ForgotPassword": {
                    "Title": "Forgot Password",
                    "Subtitle": "Enter your email to receive a password reset link.",
                    "EmailLabel": "Email address",
                    "EmailPlaceholder": "Enter your email",
                    "SendButton": "Send Reset Link",
                    "Validation": {
                        "EmailRequired": "Email is required.",
                        "EmailInvalid": "Please enter a valid email address."
                    },
                    "Success": "If this email exists, a reset link has been sent."
                },
                "ResetPassword": {
                    "Title": "Reset Password",
                    "Subtitle": "Enter your new password below.",
                    "NewPasswordLabel": "New Password",
                    "NewPasswordPlaceholder": "Enter new password",
                    "ConfirmPasswordLabel": "Confirm New Password",
                    "ConfirmPasswordPlaceholder": "Confirm new password",
                    "SubmitButton": "Reset Password",
                    "Validation": {
                        "BothFieldsRequired": "Both fields are required.",
                        "PasswordLength": "Password must be at least 6 characters.",
                        "PasswordsDoNotMatch": "Passwords do not match."
                    },
                    "Success": "Your password has been reset successfully."
                },
                "LanguageSwitcher": {
                    "SelectLanguage": "Select Language"
                },
                "Search": {
                    "Title": "Search",
                    "Placeholder": "Search campaigns, pages...",
                    "Submit": "Search",
                    "FilterBy": "Filter:",
                    "AllTypes": "All",
                    "EnterQuery": "Enter a keyword to search.",
                    "Loading": "Searching...",
                    "Error": "Search failed. Please try again.",
                    "ResultsCount": "{{count}} results for \"{{query}}\"",
                    "NoResults": "No results found for \"{{query}}\".",
                    "Nav": {
                        "Toggle": "Open search",
                        "Placeholder": "Search...",
                        "Submit": "Search"
                    },
                    "Campaigns": "Campaigns",
                    "Pages": "Pages",
                },
                "Archive": {
                    "Download": "Download",
                    "NoFiles": "No files available."
                }
            }
        },
        ar: {
            translation: {
                "Download": "حفظ",
                "QrCode": "كود QR",
                "Open": "عرض",
                "CopyLink": "نسخ الرابط",
                "LinkCopied":"تم نسخ الرابط إلى الحافظة",
                "Progress": "التقدم",
                "ImportantLinks": "",
                "DonateNow": "تبرع الآن",
                "AboutUs": "عننا",
                "ChoosePayment":"اختر وسيلة الدفع",
                "ContactUs": {
                    "Title": "تواصل معنا",
                    "Description": "هل لديك أسئلة أو ملاحظات؟ نحب أن نسمع منك. املأ النموذج أدناه وسنرد عليك في أقرب وقت ممكن.",
                    "Form": {
                        "FirstName": "الاسم الأول",
                        "Email": "البريد الإلكتروني",
                        "PhoneNumber": "رقم الهاتف",
                        "Subject": "الموضوع",
                        "Message": "الرسالة",
                        "EnterFirstName": "ادخل اسمك الأول",
                        "EnterEmail": "ادخل بريدك الإلكتروني",
                        "EnterPhone": "ادخل رقم هاتفك",
                        "EnterSubject": "ادخل الموضوع",
                        "EnterMessage": "ادخل رسالتك",
                        "SendMessage": "إرسال الرسالة",
                        "Sending": "جاري الإرسال...",
                        "Validation": {
                            "FirstNameRequired": "الاسم الأول مطلوب",
                            "EmailRequired": "البريد الإلكتروني مطلوب",
                            "EmailInvalid": "الرجاء إدخال بريد إلكتروني صحيح",
                            "PhoneRequired": "رقم الهاتف مطلوب",
                            "PhoneInvalid": "الرجاء إدخال رقم هاتف صحيح",
                            "SubjectRequired": "الموضوع مطلوب",
                            "MessageRequired": "الرسالة مطلوبة",
                            "MessageLength": "يجب أن تكون الرسالة 10 أحرف على الأقل"
                        },
                        "Success": "تم إرسال الرسالة بنجاح",
                        "Error": "فشل في إرسال الرسالة. الرجاء المحاولة مرة أخرى."
                    }
                },
                "AboutCampaign": "عن الحملة",
                "Share": "مشاركة",
                "CampaignGallery": "معرض الصور",
                "GeneralDonation": {
                    "Processing": "جاري معالجة تبرعك...",
                    "DonationType": "وجه التبرع",
                    "DonationTypeToggle": "نوع التبرع",
                    "DonationProgram": "برنامج التبرع",
                    "NoPrograms": "لا توجد برامج متاحة لهذا الوجه"
                },
                "DonationForm":{
                    "DonationAmount": "مبلغ التبرع",
                    "FirstName": "الاسم الأول",
                    "LastName": "الاسم الأخير",
                    "Email": "البريد الإلكتروني",
                    "PhoneNumber": "رقم الهاتف",
                    "Message": "الرسالة",
                    "EnterYourFirstName": "ادخل اسمك الأول",
                    "EnterYourLastName": "ادخل اسمك الأخير",
                    "EnterYourEmail": "ادخل بريدك الإلكتروني",
                    "EnterYourPhoneNumber": "ادخل رقم هاتفك",
                    "EnterYourMessage": "ادخل رسالتك",
                    "DonateAnonymously": "تبرع بأسم غير معروف",
                    "CustomAmount": "مبلغ مخصص",
                    "EnterCustomAmount": "ادخل مبلغ مخصص",
                    "Validation": {
                        "FirstNameRequired": "الاسم الأول مطلوب",
                        "LastNameRequired": "الاسم الأخير مطلوب",
                        "EmailRequired": "البريد الإلكتروني مطلوب",
                        "EmailInvalid": "الرجاء إدخال بريد إلكتروني صحيح",
                        "PhoneNumberRequired": "رقم الهاتف مطلوب",
                        "CustomAmountRequired": "يجب أن يكون المبلغ المخصص 10 على الأقل",
                        "PaymentMethodRequired": "طريقة الدفع مطلوبة"
                    },
                    "OneTimeDonation": "تبرع مرة واحدة",
                    "MonthlyDonation": "تبرع شهري",
                    "NoonOnlyNotice": "الدفع الشهري يتم عبر بوابة Noon فقط",
                    "PaymentMethod": "بوابة الدفع",
                    "Disclaimer": "من اجل راحتك أختر بوابة الدفع المفضلة لك, في حالة فشل العملية على أحداها يمكنك اعادة المحاولة على باقي البوابات المتاحة.",
                    "SecurePaymentDisclaimer": "كل بياناتك ومعاملاتك آمنة"
                },
                "Membership": {
                    "WelcomeBack": "مرحباً بعودتك",
                    "CreateAccount": "إنشاء حساب",
                    "SignInToContinue": "سجل دخول للوصول إلى حسابك",
                    "JoinUs": "انضم إلينا وابدأ في إحداث فرق",
                    "Login": "تسجيل الدخول",
                    "Register": "إنشاء حساب",
                    "Username": "اسم المستخدم",
                    "EnterUsername": "أدخل اسم المستخدم",
                    "PhoneNumber": "رقم الهاتف",
                    "EnterPhoneNumber": "أدخل رقم هاتفك",
                    "Email": "البريد الإلكتروني",
                    "EnterEmail": "أدخل بريدك الإلكتروني",
                    "Password": "كلمة المرور",
                    "EnterPassword": "أدخل كلمة المرور",
                    "ConfirmPassword": "تأكيد كلمة المرور",
                    "EnterConfirmPassword": "تأكيد كلمة المرور",
                    "SignIn": "تسجيل الدخول",
                    "OrLoginWith": "أو سجل الدخول عبر",
                    "CreateAccount": "إنشاء حساب",
                    "ForgotPassword": "نسيت كلمة المرور",
                    "LoginToDonate": "الرجاء تسجيل الدخول أو إنشاء حساب للاستمرار في تبرعك.",
                    "Validation": {
                        "UsernameRequired": "اسم المستخدم مطلوب",
                        "PhoneRequired": "رقم الهاتف مطلوب",
                        "EmailRequired": "البريد الإلكتروني مطلوب",
                        "EmailInvalid": "البريد الإلكتروني غير صالح",
                        "PasswordRequired": "كلمة المرور مطلوبة",
                        "PasswordLength": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
                        "PasswordsDoNotMatch": "كلمات المرور غير متطابقة"
                    },
                    "LoginSuccess": "تم تسجيل الدخول بنجاح",
                    "RegisterSuccess": " تم إنشاء الحساب بنجاح برجاء تفعيل الحساب عبر البريد الإلكتروني",
                    "RegisterFailed": "فشل إنشاء الحساب"
                },
                "Callback": {
                    "Title": "تفاصيل الدفع",
                    "Loading": "جاري تحميل تفاصيل الدفع...",
                    "NoDetails": "لم يتم العثور على تفاصيل الدفع",
                    "Labels": {
                        "Name": "الاسم",
                        "Description": "الوصف",
                        "Status": "الحالة",
                        "Date": "التاريخ",
                        "Amount": "المبلغ",
                        "Email": "البريد الإلكتروني",
                        "Mobile": "رقم الهاتف",
                        "PaymentMethod": "طريقة الدفع",
                        "TransactionId": "رقم العملية"
                    },
                    "Status": {
                        "Completed": "مكتمل",
                        "Unpaid": "غير مدفوع"
                    },
                    "Buttons": {
                        "Back": "رجوع",
                        "Print": "طباعة",
                        "Copy": "نسخ إلى الحافظة"
                    },
                    "Print": {
                        "Title": "إيصال الدفع"
                    }
                },
                "DonorProfile": {
                    "Title": "الملف الشخصي للمتبرع",
                    "Back": "رجوع",
                    "Logout": "تسجيل الخروج",
                    "ContactInformation": "معلومات الاتصال",
                    "DonationStats": "إحصائيات التبرع",
                    "TotalDonations": "إجمالي التبرعات",
                    "TotalGiven": "إجمالي المبلغ",
                    "LastDonation": "آخر تبرع",
                    "DonationHistory": "سجل التبرعات",
                    "ShowingDonations": "عرض {{count}} تبرعات",
                    "Donations": "التبرعات",
                    "Subscriptions": "الاشتراكات",
                    "ShowingSubscriptions": "عرض {{count}} اشتراكات",
                    "Table": {
                        "Campaign": "الحملة",
                        "Amount": "المبلغ",
                        "Date": "التاريخ",
                        "StartDate": "تاريخ البدء",
                        "NextBillingDate": "تاريخ الفوترة القادم",
                        "Recurring": "متكرر",
                        "Normal": "عادي",
                        "NextMonth": "الشهر القادم",
                        "CalendarMonth": "الشهر الميلادي",
                        "Status": "الحالة",
                        "TransactionId": "رقم العملية",
                        "LinkGenerated": "غير مدفوع",
                        "DonationsHistory": "سجل التبرعات",
                        "SubscriptionsHistory": "سجل الاشتراكات",
                        "RecurringMode": "وضع التكرار",
                        "Actions": "الإجراءات"
                    },
                    "RecurringModal": {
                        "Title": "إدارة الاشتراك المتكرر",
                        "StartedOn": "بدأ في",
                        "RecurringStatus": "حالة التكرار",
                        "SubscriptionStatus": "حالة الاشتراك",
                        "SubscriptionActive": "اشتراكك نشط",
                        "SubscriptionSuspended": "اشتراكك معلق",
                        "SubscriptionDetails": "تفاصيل الاشتراك",
                        "Mode": "الوضع",
                        "Amount": "المبلغ",
                        "NextBilling": "تاريخ الفوترة القادم",
                        "CancelSubscription": "إلغاء الاشتراك المتكرر",
                        "Close": "إغلاق",
                        "StatusUpdated": "تم تحديث حالة الاشتراك بنجاح",
                        "UpdateFailed": "فشل تحديث حالة الاشتراك",
                        "SubscriptionCancelled": "تم إلغاء الاشتراك بنجاح",
                        "CancelFailed": "فشل إلغاء الاشتراك"
                    },
                    "Loading": "جاري التحميل...",
                    "NoDonations": "لا يوجد تبرعات",
                    "DonateNow": "تبرع الآن",
                    "CompleteProfilePrompt": "يرجى إكمال ملفك الشخصي بإضافة رقم هاتف.",
                    "UpdateNow": "تحديث الآن",
                    "CompleteYourProfile": "إكمال ملفك الشخصي",
                    "PhoneMissingPrompt": "يرجى إضافة رقم هاتف لكي نتمكن من مساعدتك بشكل أفضل وإبقائك على اطلاع دائم.",
                    "Skip": "تخطي الآن",
                    "Save": "حفظ",
                    "PhoneUpdated": "تم حفظ رقم الهاتف بنجاح!",
                    "ErrorFetchingData": "فشل تحميل بيانات الملف الشخصي"
                },
                "ForgotPassword": {
                    "Title": "نسيت كلمة المرور",
                    "Subtitle": "أدخل بريدك الإلكتروني لاستلام رابط إعادة تعيين كلمة المرور.",
                    "EmailLabel": "البريد الإلكتروني",
                    "EmailPlaceholder": "أدخل بريدك الإلكتروني",
                    "SendButton": "إرسال رابط إعادة التعيين",
                    "Validation": {
                        "EmailRequired": "البريد الإلكتروني مطلوب.",
                        "EmailInvalid": "يرجى إدخال بريد إلكتروني صحيح."
                    },
                    "Success": "إذا كان هذا البريد الإلكتروني موجودًا، تم إرسال رابط إعادة التعيين."
                },
                "ResetPassword": {
                    "Title": "إعادة تعيين كلمة المرور",
                    "Subtitle": "أدخل كلمة المرور الجديدة أدناه.",
                    "NewPasswordLabel": "كلمة المرور الجديدة",
                    "NewPasswordPlaceholder": "أدخل كلمة المرور الجديدة",
                    "ConfirmPasswordLabel": "تأكيد كلمة المرور الجديدة",
                    "ConfirmPasswordPlaceholder": "تأكيد كلمة المرور الجديدة",
                    "SubmitButton": "إعادة تعيين كلمة المرور",
                    "Validation": {
                        "BothFieldsRequired": "كلا الحقلين مطلوبان.",
                        "PasswordLength": "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
                        "PasswordsDoNotMatch": "كلمتا المرور غير متطابقتين."
                    },
                    "Success": "تمت إعادة تعيين كلمة المرور بنجاح."
                },
                "LanguageSwitcher": {
                    "SelectLanguage": "اختر اللغة"
                },
                "Search": {
                    "Title": "بحث",
                    "Placeholder": "ابحث في الحملات والصفحات...",
                    "Submit": "بحث",
                    "FilterBy": "تصفية:",
                    "AllTypes": "الكل",
                    "EnterQuery": "أدخل كلمة للبحث.",
                    "Loading": "جاري البحث...",
                    "Error": "فشل البحث. حاول مرة أخرى.",
                    "ResultsCount": "{{count}} نتيجة لـ \"{{query}}\"",
                    "NoResults": "لا توجد نتائج لـ \"{{query}}\".",
                    "Nav": {
                        "Toggle": "فتح البحث",
                        "Placeholder": "بحث...",
                        "Submit": "بحث"
                    },
                    "Campaigns": "الحملات",
                    "Pages": "الصفحات",
                },
                "Archive": {
                    "Download": "تحميل",
                    "NoFiles": "لا توجد ملفات متاحة."
                }
            }
        }
    },
    lng: localStorage.getItem('selectedLanguage') || 'en',
    fallbackLng: 'en',
    interpolation: {
    escapeValue: false,
    
    },
});

export default i18n;